import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  Select as MuiSelect,
  type SelectProps as MuiSelectProps,
  styled,
} from '@mui/material';

import { StyledInputBase } from './input-base';

export const BaseSelect = styled((props: MuiSelectProps) => (
  <MuiSelect
    fullWidth
    IconComponent={ExpandMoreRoundedIcon}
    input={<StyledInputBase />}
    variant="standard"
    {...props}
  />
))({
  marginTop: '4px',
  border: '1px solid #828D98',
  borderRadius: '4px',
  paddingRight: '0px',
  width: 'unset',

  '& .MuiSelect-icon': {
    color: '#73808B',
    right: 4,
    '&.Mui-disabled': {
      color: '#B1B8BF',
    },
  },

  '&.Mui-readOnly': {
    backgroundColor: '#F9F9FA',
    border: 'none',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    paddingRight: '4px',
  },
});
